import { NavMenu } from "@shopify/app-bridge-react"
import { Link } from "react-router-dom"

import { MenuProps } from "./CommonMenu"

const ShopifyMenu = (props: MenuProps) => {
  return (
    <NavMenu>
      {props.menus.map((item) => {
        return (
          <Link to={item.path} key={item.path} rel={item?.rel}>
            {item.title}
          </Link>
        )
      })}
    </NavMenu>
  )
}

export default ShopifyMenu
